import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";


// ICON IMAGES
// import businessIcon from "../../../assets/image/iocnse1.svg";
// import touristIcon from "../../../assets/image/iocnse2.svg";
// import workIcon from "../../../assets/image/iocnse3.svg";
// import studyIcon from "../../../assets/image/iocnse4.svg";

const visaData = [
  // {
  //   id: 1,
  //   title: "Identity and Civil Documents",
  //   desc: "Immigration authorities manage files that contain several key types of information and documentation.",
  //   icon: businessIcon,
  //   color: "hover:border-[#ec4e4f]",
  //   link: "/business-visa"   // internal route
  // },
  // {
  //   id: 2,
  //   title: "Legal Status and History Records",
  //   desc: "The core of the managed files revolves around the individual's past and present legal standing in the country.",
  //   icon: touristIcon,
  //   color: "hover:border-[#ec4e4f]",
  //   link: "/tourists-visa"
  // },
  // {
  //   id: 3,
  //   title: "Supporting Evidence and Documentation",
  //   desc: "Immigration applications require substantial proof to establish eligibility for benefits. These supplemental documents are also managed as part of the complete file.",
  //   icon: workIcon,
  //   color: "hover:border-[#ec4e4f]",
  //   link: "/working-visas"
  // },
  // {
  //   id: 4,
  //   title: "Verification",
  //   desc: "Reviewing the information to determine eligibility for an immigration benefit.",
  //   icon: studyIcon,
  //   color: "hover:border-[#ec4e4f]",
  //   link: "/study-visas"
  // },


];


const VisaServices = () => {
  return (
    <section className="pt-20 ">
      <div className="max-w-7xl mx-auto px-4">
        {/* TOP CONTENT */}
        <div className="grid md:grid-cols-2 gap-10 mb-16">
          <div>
            <p className="text-sm uppercase tracking-widest font-semibold text-gray-500 mb-3">
              HOW WE HELP CLIENTS
            </p>
            <h2 className="text-3xl md:text-5xl pr-8 font-bold text-gray-900 capitalize leading-tight mb-4">
              <Link to="/services" className="hover:text-[#ec4e4f] transition">
                Type of immigration files we manage
              </Link>
            </h2>

            <div className="flex gap-2">
              <div className="w-12 h-1 bg-[#ec4e4f] "></div>
              <div className="w-1 h-1 bg-[#ec4e4f]"></div>
              <div className="w-1 h-1 bg-[#ec4e4f]"></div>
              <div className="w-1 h-1 bg-[#ec4e4f]"></div>
            </div>
          </div>

          <p className="text-xl md:text-[19px] text-[#555555] leading-relaxed">
            Our experienced team helps you maximize the success of your immigration process. We partner with dependable immigration professionals who work to achieve the best outcomes.


          </p>
        </div>
      </div>
      <div className="relative bg-gradient-to-b from-white from-40% to-[#f3f6f9] to-0% ">
        <div className="max-w-7xl mx-auto px-4">
          {/* SWIPER */}
          <Swiper
            modules={[Pagination]}
            spaceBetween={30}
            pagination={{
              clickable: false,
              dots: false,
              dynamicBullets: false
            }}
            breakpoints={{
              0: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 4 },
            }}
            className="pb-20"
          >
            {visaData.map((item) => {

              return (
                <SwiperSlide key={item.id}>

                  <div
                    className={`group relative bg-white text-center p-8 h-[370px]
                   cursor-pointer transition-all duration-300
                   border-b-2 border-[#2d5883] ${item.color}
                   hover:-translate-y-3 flex flex-col
                   shadow-md hover:shadow-xl
                   rounded-t-lg
                   mb-6`}
                  >


                    {/* ICON */}
                    <div
                      className="mx-auto mb-4 w-28 h-28 flex items-center justify-center rounded-full
                     transition-all duration-500
                    "
                    >
                      <img
                        src={item.icon}
                        alt={item.title}
                        className="w-24 h-24 transition-all duration-500
                      group-hover:scale-110"
                      />

                    </div>

                    <p className="text-[14px] uppercase tracking-wide text-[#888888] mb-2">
                      TYPES
                    </p>

                    <h3 className="text-2xl font-semibold text-gray-900 mb-4">
                      <Link to={item.link} className="hover:text-[#ec4e4f]">
                        {item.title}
                      </Link>
                    </h3>

                    <p className="text-[#555555] text-[15px] font-[400] leading-relaxed flex-grow line-clamp-3">
                      {item.desc}
                    </p>


                    {/* ARROW */}
                    <div
                      className="text-red-500 text-2xl font-bold
                    opacity-0 translate-y-3
                    group-hover:opacity-100 group-hover:translate-y-0
                    transition-all duration-500"
                    >
                      →
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>

        </div>
      </div>
    </section>
  );
};

export default VisaServices;